import React, { useState, useEffect } from "react";
import { formatCurrency } from "../utils/currencyFormatter";
import { getAllProducts, updateProduct } from "../services/productService";
import p1 from "../img/p1.jpg";
import p2 from "../img/p2.jpg";

// Map product IDs to their respective images
const productImages = {
  1: p1, // 20L Water Bottle
  2: p2, // 10L Water Bottle
};

const Product = () => {
  const [products, setProducts] = useState([]); // Initialize products as an empty array
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false); // State to manage modal visibility
  const [selectedProduct, setSelectedProduct] = useState(null); // Store selected product for editing
  const [updatedPrice, setUpdatedPrice] = useState(""); // Store the updated price
  const [updatedStock, setUpdatedStock] = useState(""); // Store the updated stock quantity

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const productData = await getAllProducts(); // Fetch products from service
        setProducts(productData);
      } catch (error) {
        console.error("Failed to fetch products:", error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  // Handle product price and stock update
  const handleUpdateProduct = async (e) => {
    e.preventDefault();

    if (!updatedPrice || isNaN(updatedPrice) || !updatedStock || isNaN(updatedStock)) {
      alert("Please enter valid price and stock.");
      return;
    }

    try {
      await updateProduct(selectedProduct.id, { unit_price: parseFloat(updatedPrice), stock_quantity: parseInt(updatedStock) });
      const updatedProducts = products.map((product) =>
        product.id === selectedProduct.id
          ? { ...product, unit_price: parseFloat(updatedPrice), stock_quantity: parseInt(updatedStock) }
          : product
      );
      setProducts(updatedProducts);
      setModalOpen(false); // Close the modal after updating
    } catch (error) {
      console.error("Error updating product:", error);
    }
  };

  return (
    <div className="container mx-auto p-4">
      <h2 className="text-2xl font-bold mb-4 text-center md:text-left">Product Management</h2>

      {loading ? (
        <div className="text-center">Loading...</div>
      ) : (
        <div className="grid gap-4 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          {products.length > 0 ? (
            products.map((product) => (
              <div
                key={product.id}
                className="bg-white shadow-md rounded-lg p-4 flex items-center justify-between"
              >
                <div className="flex-grow">
                  <h3 className="font-bold text-lg">{product.product_name}</h3>
                  <p>Price: {formatCurrency(product.unit_price)}</p>
                  <p>Stock: {product.stock_quantity}</p>
                </div>
                <img
                  src={productImages[product.id] || p1} // Use mapped image or fallback to p1
                  alt={product.product_name}
                  className="w-24 h-24 object-cover ml-4 rounded"
                />
                {/* Edit Price Button */}
                <button
                  onClick={() => {
                    setSelectedProduct(product);
                    setUpdatedPrice(product.unit_price);
                    setUpdatedStock(product.stock_quantity);
                    setModalOpen(true);
                  }}
                  className="bg-blue-500 text-white py-2 px-4 rounded-lg mt-2 md:mt-0"
                >
                  Edit Price & Stock
                </button>
              </div>
            ))
          ) : (
            <div className="text-center">No products available.</div>
          )}
        </div>
      )}

      {/* Modal for editing product price and stock */}
      {modalOpen && (
        <div className="fixed inset-0 flex justify-center items-center bg-gray-800 bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-md w-full sm:w-96">
            <h3 className="text-xl font-semibold mb-4">Edit Product Price & Stock</h3>
            <form onSubmit={handleUpdateProduct}>
              <div className="mb-4">
                <label htmlFor="productName" className="block text-sm font-medium text-gray-700">
                  Product: {selectedProduct?.product_name}
                </label>
              </div>
              <div className="mb-4">
                <label htmlFor="updatedPrice" className="block text-sm font-medium text-gray-700">
                  Price
                </label>
                <input
                  type="number"
                  id="updatedPrice"
                  value={updatedPrice}
                  onChange={(e) => setUpdatedPrice(e.target.value)}
                  className="mt-2 p-2 w-full border border-gray-300 rounded-md"
                  required
                />
              </div>
              <div className="mb-4">
                <label htmlFor="updatedStock" className="block text-sm font-medium text-gray-700">
                  Stock Quantity
                </label>
                <input
                  type="number"
                  id="updatedStock"
                  value={updatedStock}
                  onChange={(e) => setUpdatedStock(e.target.value)}
                  className="mt-2 p-2 w-full border border-gray-300 rounded-md"
                  required
                />
              </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={() => setModalOpen(false)}
                  className="mr-2 py-2 px-4 bg-gray-400 text-white rounded-md"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="py-2 px-4 bg-blue-500 text-white rounded-md"
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Product;
